import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Form, Row, Select, Spin } from 'antd';
import { validateInput } from 'pages/globals/global';
import EditButton from 'components/button/EditButton';
import UpdateButton from 'components/button/UpdateButton';
import NextPrevButton from 'components/button/NextPrevButton';
import CustomTextInput from 'components/inputs/CustomTextInput';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { Box, Dialog, DialogActions, DialogContent } from '@mui/material';
import ActiveDeactivateButton from 'components/button/ActiveDeactiveButton';
import { useUpdateReportMutation, useReportBulkActiveMutation, useReportBulkDeactivateMutation } from 'store/features/comptroller/comptrollerApi';

const ReportEditModal = ({ dataList, type, setType, editItem, showModal, setEditItem, setReloadTable, navigateLink }) => {
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [action, setAction] = useState(null);
	const [activate, setActivate] = useState(true);
	const [moduleList, setModuleList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [screenSize, setScreenSize] = useState('lg');
	const [subModuleList, setSubModuleList] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [processCodeList, setProcessCodeList] = useState([]);
	const [formSubmitData, setFormSubmitData] = useState(null);
	const [modalData, setModalData] = useState({ head: 'Confirmation', label: 'Do you want to update?' });

	const [pagination, setPagination] = useState({
		lastPage: 0,
		firstPage: 0,
		currentPage: 0,
	});

	const [counter, setCounter] = useState({
		name: 0,
		visibleIn: 0,
		moduleCode: 0,
		description: 0,
		subModuleCode: 0,
		staticFormUrl: 0,
	});

	const { profileData } = useSelector((state) => state?.profile);

	const [UpdateReport, { data: UpdateReportRes }] = useUpdateReportMutation();
	const [ActivateReport, { data: ActivateReportRes }] = useReportBulkActiveMutation();
	const [DeactivateReport, { data: DeactivateReportRes }] = useReportBulkDeactivateMutation();

	const { moduleCode, subModuleCode, name, description, staticFormUrl, visibleIn } = counter;

	const [getSelectOptionsList, { data: selectOptionsList, isSuccess: isSelectOptionsListSuccess }] = useSendControlDataMutation();

	const callGetOptionsList = ({ modules = [], subModules = [] }) => {
		const payload = {
			modules,
			subModules,
			processCodes: [],
		};

		const jsonString = JSON.stringify(payload);

		const base64Data = btoa(jsonString);

		const formattedPayload = {
			payload: payload,
			data: base64Data,
			processCode: 'reports',
			scriptName: 'modules-submodules-processCodes',
		};

		getSelectOptionsList(formattedPayload);
	};

	const handleFormChange = ({ value, name }) => {
		if (name === 'module' || name === 'subModule') {
			form.setFieldsValue({ processCode: null });

			if (name === 'module') {
				form.setFieldsValue({ subModuleCode: null });
			}

			if (name === 'module') {
				callGetOptionsList({ modules: [value], subModules: [] });
			} else if (name === 'subModule') {
				callGetOptionsList({ modules: [form.getFieldValue('moduleCode')], subModules: [value] });
			}
		}
	};

	const setFormFieldsValue = (editItem) => {
		form.setFieldsValue({
			id: editItem?.id,
			name: editItem?.name,
			moduleCode: editItem?.moduleCode,
			moduleName: editItem?.moduleName,
			reportCode: editItem?.reportCode,
			description: editItem?.description,
			processCode: editItem?.processCode,
			staticFormUrl: editItem?.staticFormUrl,
			subModuleCode: editItem?.subModuleCode,
			subModuleName: editItem?.subModuleName,
			processVersion: editItem?.processVersion,
			activationStatus: editItem?.activationStatus,
			visibleInModule: editItem?.visibleInModule,
			visibleInGlobal: editItem?.visibleInGlobal,
			visibleIn: [
				...(editItem?.visibleInGlobal ? ['visibleInGlobal'] : []),
				...(editItem?.visibleInModule ? ['visibleInModule'] : []),
			],
		});
	};

	const handleClose = () => {
		if (type === 'Edit') {
			setType('View');

			setFormFieldsValue(editItem);
		} else {
			setEditItem(null);
			setType('View');
		}
	};

	const onFieldsChange = (e) => {
		if (editItem) {
			if (e[0]?.name[0] === 'moduleCode') {
				if (e[0]?.value !== editItem?.moduleCode) {
					setCounter({
						...counter,
						moduleCode: 1,
					});
				} else {
					setCounter({
						...counter,
						moduleCode: 0,
					});
				}
			} else if (e[0]?.name[0] === 'subModuleCode') {
				if (e[0]?.value !== editItem?.subModuleCode) {
					setCounter({
						...counter,
						subModuleCode: 1,
					});
				} else {
					setCounter({
						...counter,
						subModuleCode: 0,
					});
				}
			} else if (e[0]?.name[0] === 'name') {
				if (e[0]?.value !== editItem?.name) {
					setCounter({
						...counter,
						name: 1,
					});
				} else {
					setCounter({
						...counter,
						name: 0,
					});
				}
			} else if (e[0]?.name[0] === 'visibleIn') {
				if (e[0]?.value !== editItem?.visibleIn) {
				setCounter({
					...counter,
						visibleIn: 1,
					});
				} else {
					setCounter({
						...counter,
						visibleIn: 0,
				});
				}
			} else if (e[0]?.name[0] === 'description') {
				if (e[0]?.value !== editItem?.description) {
					setCounter({
						...counter,
						description: 1,
					});
				} else {
					setCounter({
						...counter,
						description: 0,
					});
				}
			} else if (e[0]?.name[0] === 'staticFormUrl') {
				if (e[0]?.value !== editItem?.staticFormUrl) {
					setCounter({
						...counter,
						staticFormUrl: 1,
					});
				} else {
					setCounter({
						...counter,
						staticFormUrl: 0,
					});
				}
			}
		}
	};

	const handleSubmit = (data, action) => {
		if (action === 'w-i-p') {
			setAction('w-i-p');

			setModalData({ head: 'Confirmation', label: 'Do you want to W-I-P?' });
		} else if (action === 'activeDeactivate') {
			setAction('activeDeactivate');

			setModalData({ head: 'Confirmation', label: `Do you want to ${data?.activationStatus === 'Active' ? 'deactivate' : 'activate'}?` });
		} else {
			setAction(null);

			setModalData({ head: 'Confirmation', label: 'Do you want to update?' });
		}

		setConfirmModal(true);

		setFormSubmitData(data);
	};

	const handleUpdate = (data) => {
		if (editItem) {
			const payload = {
				id: data?.id,
				name: data.name ?? '',
				moduleCode: data.moduleCode,
				moduleName: data.moduleName,
				reportCode: data.reportCode,
				activationStatus: data?.activationStatus,
				// processCode: data?.processCode,
				// processName: data?.processName,
				createdBy: profileData?.userId,
				modifiedBy: profileData?.userId,
				description: data?.description ?? '',
				staticFormUrl: data?.staticFormUrl ?? '',
				// processVersion: data?.processVersion,
				subModuleCode: data.subModuleCode ?? '',
				subModuleName: data.subModuleName ?? '',
				visibleInModule: data.visibleInModule ?? false,
				visibleInGlobal: data.visibleInGlobal ?? false,
				companyCode: profileData?.creatorOrganizationId,
			};

			UpdateReport(payload);
		}
	};

	const handleActiveDeactivate = () => {
		if (editItem?.activationStatus === 'W-I-P' || editItem?.activationStatus === 'Inactive') {
			const payload = {
				id: editItem?.id,
			};

			ActivateReport({ data: [payload] });
		} else if (editItem?.activationStatus === 'Active') {
			const payload = {
				id: editItem?.id,
			};

			DeactivateReport({ data: [payload] });
		}
	};

	useEffect(() => {
		callGetOptionsList({ modules: [], subModules: [] });
	}, []);

	useEffect(() => {
		if (isSelectOptionsListSuccess) {
			setModuleList(selectOptionsList?.responseData?.moduleList ?? []);
			setSubModuleList(selectOptionsList?.responseData?.subModuleList ?? []);
			//setProcessCodeList(selectOptionsList?.responseData?.processCodeList ?? []);
		}
	}, [isSelectOptionsListSuccess]);

	useEffect(() => {
		if (editItem) {
			setFormFieldsValue(editItem);

			setIsLoading(false);
		}
	}, [editItem, form]);

	useEffect(() => {
		if (moduleCode === 1 || subModuleCode === 1 || name === 1 || description === 1 || staticFormUrl === 1 || visibleIn === 1) {
			setActivate(false);
		} else {
			setActivate(true);
		}
	}, [counter]);

	useEffect(() => {
		if (UpdateReportRes?.status === 'SUCCESS') {
			toast.success('Success! Action completed.', toastConfig);

			if (!navigateLink) {
				setType('View');
				setReloadTable((prev) => !prev);
			} else {
				navigate(navigateLink);
			}

			setEditItem(null);
		} else if (UpdateReportRes?.code === '502') {
			toast.error(UpdateReportRes?.message, toastConfig);
		} else if (UpdateReportRes?.status === 'FAILED') {
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [UpdateReportRes]);

	useEffect(() => {
		if (ActivateReportRes?.result?.[0]?.status === 'SUCCESS') {
			toast.success('Success! Action completed.', toastConfig);

			if (!navigateLink) {
				setType('View');
				setReloadTable((prev) => !prev);
			} else {
				navigate(navigateLink);
			}

			setEditItem(null);
		} else if (ActivateReportRes?.result?.[0]?.message) {
			toast.error(ActivateReportRes?.result?.[0]?.message, toastConfig);
		} else if (ActivateReportRes?.result?.[0]?.status === 'FAILURE') {
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [ActivateReportRes]);

	useEffect(() => {
		if (DeactivateReportRes?.result?.[0]?.status === 'SUCCESS') {
			toast.success('Success! Action completed.', toastConfig);

			if (!navigateLink) {
				setType('View');
				setReloadTable((prev) => !prev);
			} else {
				navigate(navigateLink);
			}

			setEditItem(null);
		} else if (DeactivateReportRes?.result?.[0]?.message) {
			toast.error(DeactivateReportRes?.result?.[0]?.message, toastConfig);
		} else if (DeactivateReportRes?.result?.[0]?.status === 'FAILURE') {
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [DeactivateReportRes]);

	return (
		<Spin spinning={isLoading}>
			<Dialog
				keepMounted
				open={showModal}
				fullWidth={true}
				maxWidth={screenSize}
				aria-labelledby="draggable-dialog-title"
				fullScreen={screenSize === 'full' ? true : false}
				sx={{
					'.MuiPaper-root': {
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
						overflow: 'hidden',
					},
				}}
			>
				<ViewEditModalHeader
					type={type}
					headerTitle="Report"
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
				/>

				<DialogContent
					sx={{
						pb: 0,
						pt: 1.5,
						px: 2,
						backgroundColor: '#FFFFFF',

						'& .ant-form-item-label': {
							paddingBottom: '12px',
						},
					}}
				>
					<Form
						form={form}
						id="coe-module"
						layout="vertical"
						autoComplete="off"
						requiredMark={false}
						onFinish={handleSubmit}
						onFieldsChange={onFieldsChange}
					>
						<Row gutter={[16, 0]}>
							<Form.Item noStyle name="id" />
							<Form.Item noStyle name="reportCode" />
							<Form.Item noStyle name="moduleName" />
							{/* <Form.Item noStyle name="processName" /> */}
							<Form.Item noStyle name="subModuleName" />
							{/* <Form.Item noStyle name="processVersion" /> */}
							<Form.Item noStyle name="activationStatus" />
							<Form.Item noStyle name="visibleInModule" />
							<Form.Item noStyle name="visibleInGlobal" />

							<Col xs={24}>
								<Form.Item name="moduleCode" label="Module">
									<Select
										allowClear
										placeholder="Select user"
										style={{ width: '100%' }}
										disabled={type === 'View' ? true : false}
										onChange={(value, option) => {
											form.setFieldsValue({
												moduleName: option?.children || '',
											});

											handleFormChange({ value, name: 'module' });
										}}
										rules={[
											{
												required: true,
												message: 'Module is required',
											},
										]}
									>
										{moduleList?.map((module) => (
											<Select.Option value={module?.moduleCode} key={module?.moduleName}>
												{module?.moduleName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24}>
								<Form.Item name="subModuleCode" label="Sub Module">
									<Select
										allowClear
										placeholder="Select user"
										style={{ width: '100%' }}
										disabled={type === 'View' ? true : false}
										onChange={(value, option) => {
											form.setFieldsValue({
												subModuleName: option?.children || '',
											});

											handleFormChange({ value, name: 'subModule' });
										}}
										rules={[
											{
												required: true,
												message: 'Sub module is required',
											},
										]}
									>
										{subModuleList?.map((subModule) => (
											<Select.Option value={subModule?.subModuleCode} key={subModule?.subModuleName}>
												{subModule?.subModuleName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24}>
							<Form.Item name="visibleIn" label="Visible In">
								<Select
									allowClear
									mode="multiple"
									style={{ width: '100%' }}
									placeholder="Select user"
									disabled={type === 'View' ? true : false}
									onChange={(value, option) => {
										if(value?.includes('visibleInGlobal')) {
											form.setFieldsValue({
												visibleInGlobal: true,
											});
										} else {
											form.setFieldsValue({
												visibleInGlobal: false,
											});
										}

										if(value?.includes('visibleInModule')) {
											form.setFieldsValue({
												visibleInModule: true,
											});
										} else {
											form.setFieldsValue({
												visibleInModule: false,
											});
										}	
									}}
									rules={[
										{
											required: true,
											message: 'Process code is required',
										},
									]}
								>
									{[{name: 'Global', value: 'visibleInGlobal'}, {name: 'Module', value: 'visibleInModule'}]?.map((processCode) => (
										<Select.Option value={processCode?.value} key={processCode?.value}>
											{processCode?.name}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

							{editItem && (
								<>
									<Col xs={24}>
										<CustomTextInput
											form={form}
											label="Code"
											name="reportCode"
											disabled={editItem}
											placeholder="Enter Code Here"
										/>
									</Col>
								</>
							)}

							<Col xs={24}>
								<CustomTextInput
									form={form}
									name="name"
									label="Report Name"
									placeholder="Enter report name"
									disabled={type === 'View' ? true : false}
									rules={[
										{
											validator: validateInput,
										},
									]}
								/>
							</Col>

							<Col xs={24}>
								<CustomTextInput
									form={form}
									name="description"
									label="Short Description"
									placeholder="Enter short description"
									disabled={type === 'View' ? true : false}
									rules={[
										{
											validator: validateInput,
										},
									]}
								/>
							</Col>

							<Col xs={24}>
								<CustomTextInput
									form={form}
									name="staticFormUrl"
									label="Static Form URL"
									placeholder="Enter static form URL"
									disabled={type === 'View' ? true : false}
									rules={[
										{
											validator: validateInput,
										},
									]}
								/>
							</Col>
						</Row>

						<DialogActions sx={{ px: 0, pb: 4, pt: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
								{type === 'View' && (
									<>
										<EditButton
											handleOnClick={(e) => {
												e.stopPropagation();

												setType('Edit');
											}}
										/>

										<ActiveDeactivateButton
											activationStatus={editItem?.activationStatus}
											handleOnClick={(e) => {
												e.stopPropagation();

												handleSubmit(editItem, 'activeDeactivate');
											}}
										/>
									</>
								)}

								{type === 'Edit' && <UpdateButton title="Update" disabled={activate} />}
							</Box>

							<NextPrevButton
								type={type}
								dataList={dataList}
								editItem={editItem}
								pagination={pagination}
								setEditItem={setEditItem}
								setIsLoading={setIsLoading}
								setPagination={setPagination}
							/>
						</DialogActions>
					</Form>
				</DialogContent>
			</Dialog>

			{confirmModal && (
				<ComptrollerConfirmModal
					modalData={modalData}
					showModal={confirmModal}
					setShowModal={setConfirmModal}
					handleSubmit={() => (action === 'activeDeactivate' ? handleActiveDeactivate() : handleUpdate(formSubmitData))}
				/>
			)}
		</Spin>
	);
};

export default ReportEditModal;
